//GeneratorFlag:[NoChange]
<template>
	<div>kaveh.app.toolbar.notification.notification</div>
</template>